export enum PeopleTab {
    EVERYONE = 'everyone',
    TEAMS = 'teams',
    CARDS = 'cards',
    ACCOUNTANT = 'accountant',
}
